export default __webpack_public_path__ + "static/media/handTattoo.483ec44f.jpeg";